/* eslint-disable no-unused-expressions */
import { Grid } from '@mui/material';
import React from 'react';
import NewPage from '../components/NewPage';

import CalendarRegisterContainer from '../containers/calendar/CalendarRegisterContainer';
import CalendarStatusContainer from '../containers/calendar/CalendarStatusContainer';

const CalendarPage = () => {
  return (
    <NewPage title="일정">
      <Grid item xs={12}>
        <CalendarRegisterContainer />
      </Grid>
      <Grid item xs={12}>
        <CalendarStatusContainer />
      </Grid>
    </NewPage>
  );
};

export default CalendarPage;
